require('../../modules/es.set');
require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
var path = require('../../internals/path');

module.exports = path.Set;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/es/set/index.js
// module id = 1291
// module chunks = 1